import { useAuth0 } from '@auth0/auth0-react'
import { TagInput } from 'domain/entities/Tag'
import { GraphQLTagRepository } from 'infrastructure/graphql/TagRepositoryImpl'
import { useCallback, useState } from 'react'

export function useCreateTag() {
  const { getIdTokenClaims } = useAuth0()
  const [creating, setCreating] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const createTag = useCallback(
    async (input: TagInput) => {
      setCreating(true)
      setError(null)
      try {
        const getToken = async () => (await getIdTokenClaims())?.__raw ?? ''
        const repo = new GraphQLTagRepository(getToken)
        const created = await repo.create(input)
        return created
      } catch (err: any) {
        setError(err)
        throw err
      } finally {
        setCreating(false)
      }
    },
    [getIdTokenClaims]
  )

  return { createTag, creating, error }
}
